/* eslint-disable vue/no-unused-vars */
/* eslint-disable */

<template>
  <div class=" bg-green-800 flex justify-center">
    <div class="bg-white w-full xl:w-4/5">
      <div class="description-header">
        <div
          class="bg-green-lightest text-green-dark flex flex-row items-center bg-green-600 mb-1 shadow-md"
          role="alert"
        >
          <h2 class="mr-2  text-white py-2 px-2 text-xl w-72 flex-grow">
            {{ item.titel }}
          </h2>

          <div>
            <a
              :href="item.editLink"
              class="underline cursor-pointer mr-2 text-white"
              target="_blank"
            >Edit</a>
          </div>
        </div>
      </div>

      <div class="flex w-full">
        <div
          :class="{ 'w-1/2  border-r-4 pr-2  content-border': hasTextContent }"
          class="flex flex-col   overflow-hidden"
        >
          <div class="flex flex-col justify-center align-middle">
            <sc-media-image :image-id="imgId" />
            <div class="flex flex-row m-2 p-1 ">
              <sc-media-image
                v-for="(asset,index) in item.assetIds"
                :key="asset"
                :image-id="asset"
                class="cursor-pointer mr-2 border border-black border-solid h-16 w-24 rounded-lg"
                @click="setAsset(index)"
              />
              <!--//TODO Exract Media component -->
              <div v-if="item.medias && item.medias.length>0">
                <div
                  v-for="link in item.medias"
                  :key="link.Url"

                  class="flex justify-center"
                >
                  <img
                    v-if="item.kind==7"
                    height="64"
                    width="64"
                    class="cursor-pointer mr-2 border border-black border-solid h-16 w-16 rounded-lg  "
                    src="https://lh3.googleusercontent.com/arScjoq0DLDl3lK1AkIyVkMYKRaNgvEtuX88jINO49AZ6pGRciwDP1w392s0Y1kym7g=w160"
                  >
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="functionalAllowed && item.medias && item.medias.length>0"
            class="flex flex-col text-xs">
            <div
              v-for="link in item.medias"
              :key="link.url"
              class="flex justify-center"
            >
              <iframe
                v-if="link.kind==6"
                id="vmplayer"
                :src="buildVimeoLink(link)"
                width="640"
                height="365"
                frameborder="0"
                webkitallowfullscreen
                mozallowfullscreen
                allowfullscreen
              />
              <iframe
                v-if="link.kind==7"
                id="ytplayer"
                type="text/html"
                width="640"
                height="360"
                :src="buildYoutubeLink(link)"
                frameborder="0"
              />

              <iframe
                v-if="link.kind==8"
                :src="buildgDriveLink(link)"
                width="640"
                height="360"
              />
            </div>
          </div>
          <div
            v-else
            class="lg:m-10"
          >
            <pv-panel header="Externe Medien" v-if="item.medias && item.medias.length>0">
              <div class="w-full">
                <div
                  v-if="item.medias && item.medias.length>0"
                  class="flex flex-col text-xs mb-2"
                >
                  <div
                    v-for="link in item.medias"
                    :key="link.url"
                    class="flex justify-start"
                  >
                    <a
                      :href="link.url"
                      target="_blank"
                    >
                      {{ link.url }}
                    </a>
                  </div>
                </div>
              </div>
              <contentConsent consent-name="Funktionale" />
            </pv-panel>
          </div>

          <div
            v-if="item.preparatoryExercise && item.preparatoryExercise.length>0"
            class="ml-2"
          >
            <h2 class="bg-green-lightest text-green-dark  pl-2 py-1 mb-1">
              Vorbereitende Übungen
            </h2>
            <div class="flex flex-row text-xs mb-2 flex-wrap">
              <router-link
                v-for="item in item.preparatoryExercise"
                :key="item.key"
                :to="item.key"
              >
                <sc-exercise-small
                  :key="item.key"
                  :title="item.title"
                  :image="item.image"
                  :short-key="item.key"
                  :show-add-button="false"
                  :show-open-button="true"
                />
              </router-link>
            </div>
          </div>

          <div
            v-if="item.subsequentExercise && item.subsequentExercise.length>0"
            class="ml-2"
          >
            <h2 class="bg-green-lightest text-green-dark pl-2 py-1 mb-1">
              Aufbauende Übungen
            </h2>
            <div class="flex flex-row text-xs mb-2 flex-wrap">
              <router-link
                v-for="item in item.subsequentExercise"
                :key="item.key"
                :to="item.key"
              >
                <sc-exercise-small
                  :key="item.key"
                  :title="item.title"
                  :image="item.image"
                  :short-key="item.key"
                  :show-add-button="false"
                  :show-open-button="true"
                />
              </router-link>
            </div>
          </div>
        </div>

        <div
          v-if="hasTextContent"
          class="w-1/2 overflow-hidden"
        >
          <div class="description p">
            <h2 class="bg-green-600 text-white p-2 mb-1 text-xl">
              Auf einen Blick
            </h2>
            <div class="flex flex-row text-grey-darker mb-1 items-center text-sm h pl-2">
              <sc-difficulty :difficulty="item.difficulty" />
            </div>

            <div class="flex flex-row text-grey-darker mb-1 items-center text-sm h pl-2">
              <div class="font-bold w-24">
                Intensität:
              </div>
              <div
                class="flex flex-row ml-2"
                :class="colorIntensity(item)"
              >
                <div
                  v-for="i in item.intensity"
                  :key="i"
                >
                  <i class="text-xs fas fa-star" />
                </div>
              </div>

              <div
                v-for="i in emptyIntensitySquares(item)"
                :key="i"
              >
                <i
                  style="margin: 0.125rem"
                  class="text-xs far fa-star text-gray-400"
                />
              </div>
            </div>
            <div class="pl-2 flex flex-wrap text-xs align-bottom font-semibold text-grey-darker">
              <tag-list :tags="item.tags" />
            </div>
          </div>

          <div class="description">
            <h2 class="bg-green-600 text-white p-2 mb-1 text-xl">
              Organisation
            </h2>
            <div
              class="ml-2"
              v-html="item.composition"
            />
          </div>

          <div
            v-if="item.procedure"
            class="description"
          >
            <h2 class="bg-green-600 text-white p-2 pl-2 py-1 mb-1  text-xl">
              Ablauf
            </h2>
            <div
              class="ml-2"
              v-html="item.procedure"
            />
          </div>

          <div
            v-if="item.variations"
            class="description"
          >
            <h2 class="bg-green-600 text-white p-2 pl-2 py-1 mb-1  text-xl">
              Variationen
            </h2>
            <div
              class="ml-2"
              v-html="item.variations"
            />
          </div>

          <div
            v-if="item.coachingHints"
            class="description"
          >
            <h2 class="bg-green-600 text-white p-2 pl-2 py-1 mb-1  text-xl">
              Tipps & Korrekturen
            </h2>
            <div
              class="ml-2"
              v-html="item.coachingHints"
            />
          </div>

          <div>
            <div
              v-if="item && item.medias && item.medias.length>0"
              class="description "
            >
              <h2 class="bg-green-600 text-white p-2 pl-2 py-1 mb-1  text-xl">
                Links
              </h2>
              <div class="ml-4 mt-4">
                <ul>
                  <li
                    v-for="link in item.medias"
                    :key="link.url"
                    class="underline text-xl text-blue-500"
                  >
                    <a
                      target="_blank"
                      :href="link.url"
                      class="mb-2"
                    >{{ link.url }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiService from '../api/apiService'
import TagList from '../tagList'
import contentConsent from '../cookies/contentConsent'

export default {
    name: 'ExerciseDetail',
    components: { TagList, contentConsent },
    data () {
        return {
            imgId: null,
            item: {},
            key: '',
            assetPosition: 0,
            functionalAllowed: false
        }
    },
    computed: {
        hasTextContent () {
            return this.item &&
          (this.hasText(this.item.composition) || this.hasText(this.item.procedure) || this.hasText(this.item.variations) || this.hasText(this.item.coachingHints))
        }

    },
    async mounted () {
        const cookie = this.$cookies.get('cookiefirst-consent')
        const functional = cookie && cookie.functional
        this.functionalAllowed = functional
        this.key = this.$route.params.key
        this.item = await this.getDetails()

        const curItem = this.item
        if (curItem && curItem.assetIds && curItem.assetIds.length > 0) {
            this.imgId = curItem.assetIds[0]
        }
    },
    methods: {
        async changeExercise (key) {
            this.key = key
            this.item = await this.getDetails()

            this.$router.push({ params: { key: key }, force: true })
        },

        setAsset (index) {
            console.log('setting assset: ' + index)
            this.assetPosition = index
            this.imgId = this.item.assetIds[index]
        },
        async getDetails () {
            const { data } = await apiService.getExerciseByKey(this.key)
            return data
        },

        buildYoutubeLink (link) {
        // TODO extract to api
            const src = 'https://www.youtube.com/embed/' + link.value
            return src
        },

        buildVimeoLink (link) {
            return 'https://player.vimeo.com/video/' + link.value + '?title=0&byline=0&portrait=0'
        },

        buildgDriveLink (link) {
            return 'https://drive.google.com/file/d/' + link.value + '/preview'
        },

        hasText (text) {
            return text && text.length > 1
        },

        colorIntensity (item) {
            if (item.intensity < 3) {
                return 'text-green-600'
            } else if (item.intensity === 3) {
                return 'text-yellow-600'
            } else if (item.intensity === 4) {
                return 'text-orange-600'
            } else if (item.intensity >= 5) {
                return 'text-red-600'
            }
        },
        emptyIntensitySquares (item) {
            return 5 - item.intensity
        }

    }
}
</script>

<style lang="scss" scoped>
  .description {
    margin-bottom: 24px;
    white-space: pre-line;
    font-family: serif;
  }

  .description-header {
    color: #08985A;
  }

  .content-border {
    border-color: #0F4929;
  }

</style>
